<template>
  <table class="striped admin-manufacturers-table">
    <caption v-html="caption" v-if="caption" />
    <thead>
      <tr>
        <th>Manufacturer</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="manufacturer in paginatedManufacturers"
        :key="manufacturer.id"
        :class="selectedId === manufacturer.id ? 'selected' : 'selectable'"
        @click="handleSelect(manufacturer)"
      >
        <td>{{ manufacturer.name }}</td>
      </tr>
      <tr v-if="manufacturers.length === 0">
        <td class="no-records">
          There are currently no manufacturers in the system.
        </td>
      </tr>
    </tbody>
    <tfoot v-if="hasPages">
      <tr>
        <td class="page-controls">
          <icon-button
            :disabled="!hasPrevPage"
            name="prev"
            @click="goToPrevPage"
          />

          <icon-button
            :disabled="!hasNextPage"
            name="next"
            @click="goToNextPage"
          />
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import { pagination } from "../../mixins/pagination";

export default {
  mixins: [pagination("manufacturers")],

  props: {
    caption: {
      type: String,
      default: undefined,
    },
    manufacturers: {
      type: Array,
    },
    selectedId: {
      type: Number,
      default: -1,
    },
  },

  methods: {
    handleSelect(manufacturer) {
      this.$emit("select", manufacturer);
    },
  },
};
</script>